import React, { useState } from "react";
import { Menu, X } from "lucide-react";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navLinks = [
    { href: "/features", en: "Features", ja: "特徴" },
    { href: "/pricing", en: "Pricing", ja: "料金" },
    { href: "/for_shops/how-to-start", en: "How to start", ja: "始め方" },
    { href: "/faq", en: "FAQ", ja: "よくある質問" },
    { href: "/contact", en: "Contact", ja: "お問い合わせ" },
  ];

  const getDashboardUrl = (path: string) => {
    return window.location.hostname.includes('localhost')
      ? `http://dashboard.joybase.localhost:${window.location.port}${path}`
      : `https://dashboard.joybase.jp${path}`;
  };

  return (
    <header className="fixed top-0 left-0 w-full z-50">
      {/* Main Header */}
      <div className="bg-[#FFFEF5] border-b-4 border-black">
        <div className="flex items-center justify-between h-16 md:h-20 px-4 md:px-8">
          {/* Left: Menu Button (Mobile) + Logo */}
          <div className="flex items-center gap-2">
            {/* Mobile Menu Button */}
            <button
              className="md:hidden w-10 h-10 bg-white border-2 border-black flex items-center justify-center hover:bg-yellow-400 transition-colors"
              onClick={toggleMenu}
              aria-label="メニューを開く"
            >
              {isMenuOpen ? (
                <X className="w-5 h-5" />
              ) : (
                <Menu className="w-5 h-5" />
              )}
            </button>

            {/* Logo */}
            <a href="/" className="flex items-center group">
              <span className="text-xl md:text-2xl font-black tracking-tight">
                <span className="text-black">JOY</span>
                <span className="relative">
                  <span className="text-black">BASE</span>
                  <span className="absolute -bottom-1 left-0 w-full h-1 bg-yellow-400 group-hover:h-2 transition-all"></span>
                </span>
              </span>
            </a>
          </div>

          {/* Center: Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-3 py-2 font-bold text-sm text-black hover:bg-yellow-400 transition-colors relative group"
              >
                <span className="block text-[10px] text-gray-500 group-hover:text-black">{link.en}</span>
                <span>{link.ja}</span>
              </a>
            ))}
          </nav>

          {/* Right: Auth Buttons */}
          <div className="flex items-center gap-2">
            <a
              href={getDashboardUrl('/login')}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:flex items-center px-4 py-2 font-bold text-sm text-black hover:text-yellow-600 transition-colors"
            >
              ログイン
            </a>

            <a
              href={getDashboardUrl('/signup')}
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 md:px-6 md:py-3 bg-black text-white font-bold text-xs md:text-sm border-2 border-black shadow-[3px_3px_0px_0px_rgba(250,204,21,1)] hover:shadow-[1px_1px_0px_0px_rgba(250,204,21,1)] hover:translate-x-[2px] hover:translate-y-[2px] transition-all"
            >
              無料ではじめる
            </a>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-[#FFFEF5] border-b-4 border-black">
          <nav className="px-4 py-4">
            {navLinks.map((link, index) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setIsMenuOpen(false)}
                className="block py-3 px-4 mb-2 bg-white border-2 border-black font-bold hover:bg-yellow-400 transition-colors"
                style={{
                  animation: `slideIn 0.2s ease-out ${index * 0.05}s both`
                }}
              >
                <span className="block text-xs text-gray-500">{link.en}</span>
                <span className="text-sm">{link.ja}</span>
              </a>
            ))}

            {/* Mobile Login Link */}
            <a
              href={getDashboardUrl('/login')}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsMenuOpen(false)}
              className="block py-3 px-4 mt-4 text-center font-bold text-sm text-black border-2 border-black bg-white hover:bg-gray-100 transition-colors"
            >
              ログイン
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
